module.exports = __webpack_public_path__ + "static/img/video_platform1.b65271e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/video_platform1.png
// module id = d+gr
// module chunks = 0